import { VENDORS_TABLE_FIELDS } from 'pages/VendorsTablePage/components/VendorsTable/constants';

export enum PaymentMethod {
  VIRTUAL_CARD = 'VIRTUAL_CARD',
  AP_CHECK = 'AP_CHECK'
}
export const SORT_COLUMN_PARAMS = {
  'ag-Grid-AutoColumn': 'VENDOR_NO',
  [VENDORS_TABLE_FIELDS.vendorName]: 'VENDOR_NAME',
  [VENDORS_TABLE_FIELDS.paymentMethod]: 'PAYMENT_METHOD',
  [VENDORS_TABLE_FIELDS.amount]: 'AMOUNT',
  [VENDORS_TABLE_FIELDS.discountAmount]: 'DISCOUNT',
  [VENDORS_TABLE_FIELDS.netAmount]: 'NET_PAYMENT'
};

export const SORT_ORDER_PARAMS = {
  asc: 'ASC',
  desc: 'DESC'
};

export const SORT_PRINT_CHECKS_COLUMN = {
  [VENDORS_TABLE_FIELDS.vendorNo]: 'VENDOR_NO',
  [VENDORS_TABLE_FIELDS.vendorName]: 'VENDOR_NAME',
  totalNetAmount: 'AMOUNT'
};

export const HIGH_VOLUME_MIN_SEARCH_LENGTH = 2;

export const HIGH_VOLUME_VENDORS_PAGE_SIZE = 125;

export const HIGH_VOLUME_PRINT_CHECKS_PAGE_SIZE = 125;

export const HIGH_VOLUME_MAX_PAGES_IN_CACHE = 10;

export const HIGH_VOLUME_BLOCK_LOAD_DEBOUNCE = 0;

export const GRID_INITIAL_ROW_COUNT = 1;

export const SELECT_ALL_CHECKS_PAGE_NO = 1;

export const SELECT_ALL_CHECKS_PAGE_SIZE = 300;

export const SELECT_ALL_INVOICES_PAGE_SIZE = 1000;

export const SELECT_ALL_INVOICES_MAX_COUNT = 5000;
